import { forwardRef, createElement } from 'react';

function IconDeveloper(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M14.303 2.787a1.25 1.25 0 01.934 1.39l-.024.126-4 16a1.25 1.25 0 01-2.45-.48l.024-.126 4-16a1.25 1.25 0 011.516-.91zM7.05 5.04a1.25 1.25 0 01.242 1.65l-.082.11L2.877 12l4.333 5.2a1.25 1.25 0 01-.06 1.667l-.1.093a1.25 1.25 0 01-1.667-.06l-.093-.1-5-6a1.25 1.25 0 01-.083-1.49l.083-.11 5-6a1.25 1.25 0 011.76-.16zm9.9 0a1.25 1.25 0 011.667.06l.093.1 5 6 .083.11a1.25 1.25 0 010 1.38l-.083.11-5 6-.093.1a1.25 1.25 0 01-1.558.142l-.11-.082-.1-.093a1.25 1.25 0 01-.14-1.558l.08-.11L21.124 12 16.79 6.8l-.082-.11a1.25 1.25 0 01.242-1.65z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Developer = /*#__PURE__*/forwardRef(IconDeveloper);

export default Developer;
//# sourceMappingURL=Developer.js.map
